import apiClient from '@/services/axios';

// NB this returns venueTrainingSessions where user data is inserted
export async function get() {
  var response = await apiClient.get("/VenueTrainingSessions?query=*");
  if (response) {
    return response.data
  }

  throw new Error("Unable to get VenueTrainingSessions")
}